<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="680"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row>
                    <Col span="24">
                        <FormItem label="名称：" prop="title">
                            <Input v-model="Forms.title" placeholder="请输入名称" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="类型：" prop="type_id">
                            <Select v-model="Forms.type_id" filterable clearable placeholder="类型" >
                                <Option v-for="(item,index) in typeList" :value="item.id" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="文件" prop="file">
                            <Input v-model="Forms.file" disabled class="width-100">
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload(Forms.file)" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="到期时间" prop="end_time">
                            <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.end_time" placeholder="到期时间" class="width-100"  />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="是否提醒：">
                            <RadioGroup v-model="Forms.is_alert" type="button">
                                <Radio :label="1">提醒</Radio>
                                <Radio :label="2">不提醒</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="Forms.is_alert === 1">
                        <FormItem label="提醒天数：" prop="alert_day" :rules="[{ required: true, type: 'number',  message: '请输入提醒天数', trigger: 'blur',  transform(value) { return parseInt(value)}  }]">
                            <Input type="number" v-model="Forms.alert_day" placeholder="请输入提前多少天提醒" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="账户状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getCertConfig, getCertDetail, saveCert} from "@/apis/cert";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增证书',
            isBox : false,
            typeList : [],
            Forms : {
                id:'',
                title: '',
                type_id: '',
                file: '',
                end_time: '',
                is_alert: 1,
                alert_day: '',
                status: 3,
                remark: ''
            },
            Rules : {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择所类型', trigger: 'change',  transform(value) { return parseInt(value)}  },
                ],
                file: [
                    { required: true, message: '请上传文件', trigger: 'blur' },
                ]
            },

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
        }
    },
    methods: {
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCertDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'type_id' || v === 'status'|| v === 'is_alert'){
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.file = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.file = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 PDF | xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2026/1/5 14:49
         **/
        GetConfig(){
            let that = this;
            getCertConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(id){
            this.isBox = true;
            this.title = '编辑证书';
            this.GetConfig();
            if(id) this.GetDetail(id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCert(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增证书';
            this.$refs['Forms'].resetFields();
            this.Forms.id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
